import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import * as S from '../scss/theme';
import fnc from "../mymod/commFunction";
import './Assess_book_checkList_result.scss';
import HongButton from "../comm/HongButton";
import { useNavigate } from "react-router-dom";

import Checkbox from '@mui/material/Checkbox';

const Assess_book_checkList_result = ({testCode, stCode, testDate}) => {
    const userInfo = useSelector((state) => state.reduxIgong.userInfo);
    const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
    const isStudent = useSelector((state) => state.reduxIgong.isStudent);
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);//체크박스
    const [selectedItemsType, setSelectedItemsType] = useState([]);//체크박스

    useEffect(() => {
        fncQuestion_etc();
        console.log(testCode, stCode, 'testCode, stCode');
    }, []);

 
    function fncQuestion_etc() {//설문조사
  
        fnc.sendAxios('/igonAssess_etcRoutes/select/book_checkList', {testCode, stCode }, (res) => {
          if (res && res.length > 0) {
           const listRes = getRecords(res);
           setList(listRes);
          } else {
            console.log("속성이 obj 내에 없습니다.");
          }
        });
      }



    function getRecords(res) {
        let records = [];

        for (let i = 0; i < res.length; i++) {      
            const sno= res[i]["sno"];
            const no= res[i]["no"];
            const no2= res[i]["no2"];
            const code= res[i]["code"];
            const typeCode = res[i]["typeCode"];
            const typeName = res[i]["typeName"];
            const genre = res[i]["genre"];
            const ability = res[i]["ability"];
            const value = res[i]["value"];
    
            records.push({ sno, no, no2, typeCode, typeName, genre, ability, value });
        }
        return records;
      }


      function onDelete() {

            // const testCode = item.testCode;
            // const stCode = item.stCode;
            // const testDate = item.testDate;

            const rtn = window.confirm(`${testDate}일자 진단을 정말로 삭제하시겠습니까?`);
            if (!rtn) return;

            fncDelete_book_marking(testCode, stCode);


            function fncDelete_book_marking(testCode, stCode) {
            fnc.sendAxios('/igonAssess_etcRoutes/delete/book_marking', { testCode, stCode }, (res) => {
                if (res) { 
                    if(res.success) {
                    // setIsRefresh(!isRefresh);
                    alert('완료되었습니다.');  
                    }
                } else {
                alert('검색에 실패했습니다.');
                }
            });
            }

      }
 
    //=============================================
    return (
 
            <div className="Assess_book_checkList_result">
                <div className='wrap-main'>
                <section className='section-list'>
                    
                <table className="table-hong">
                    <thead>
                        <tr>
                        <th>no</th>
                        <th>구분</th>
                        <th>능력</th>
                        <th>독서장르</th>
                        </tr>
                    </thead>

                    <tbody>
                        {list.map((item, index) => (
                        <tr key={item.sno} className={item.no2 % 2 === 0 ? 'group-highlight' : ''}>
                            <td className="no">{item.no}</td>
                            <td>{item.typeName}</td>
                       
                            <td>{item.ability}</td>
                            <td  className={`text-left ${item.value?.trim() == 'Y' ? 'text-red' : ''}`}>{item.genre}</td>                  
                        </tr>
                        ))}
                    </tbody>
                    </table>

                      

                </section>

                <div className="box-menu">
                   {!isStudent && <HongButton className="btn h-btn-red" onClick={onDelete}>삭제</HongButton>}
                </div>
                                

                </div>
            </div>

    );
};

export default Assess_book_checkList_result;
